export const openCatalogRoutes = {
  catalog: "/catalog",
  catalogProduct: "/catalog/products",
  catalogBrands: "/catalog/brands",
  npRedirect: "/catalog/np",
  usApp: "https://us.fullscript.com",
  caApp: "https://ca.fullscript.com",

  // fullscript marketing links
  acceptableUsePolicy: "https://fullscript.com/aup",
  accessibilityPolicy: "https://fullscript.com/accessibility",
  customerSupportPolicy: "https://fullscript.com/csp",
  about: "https://fullscript.com/about",
  caliPrivacyNotice: "https://fullscript.com/ccpa",
  careers: "https://fullscript.com/careers",
  collective: "https://fullscript.com/collective",
  culture: "https://fullscript.com/culture",
  demo: "https://fullscript.com/demo",
  education: "https://fullscript.com/blog",
  engineering: "https://fullscript.com/careers/engineering",
  events: "https://fullscript.com/events",
  faq: "https://support.fullscript.com/hc/en-us",
  fullscript: "https://fullscript.com/",
  fullscriptNowNp: "https://fullscript.com/welcome-natural-partners",
  howItWorks: "https://fullscript.com/how-it-works",
  ingredientLib: "https://fullscript.com/ingredient-library",
  integrations: "https://fullscript.com/integrations",
  leadership: "https://fullscript.com/about/#leaders",
  login: "https://fullscript.com/login",
  usLogin: "https://us.fullscript.com/login",
  caLogin: "https://ca.fullscript.com/login",
  news: "https://fullscript.com/news",
  patients: "https://fullscript.com/patients",
  practiceResources: "https://fullscript.com/practice-resources",
  practicingVirtually: "https://fullscript.com/practicing-virtually",
  pricing: "https://fullscript.com/pricing",
  privacy: "https://fullscript.com/privacy",
  protocols: "https://fullscript.com/protocols",
  spotlight: "https://fullscript.com/spotlight",
  shippingPolicy: "https://support.fullscript.com/articles/patient-shipping-policy/",
  signUp: "http://fullscript.com/practitioner-signup",
  usAppSignUp: "https://us.fullscript.com/practitioner-signup",
  caAppSignUp: "https://ca.fullscript.com/practitioner-signup",
  supplementQuality: "https://fullscript.com/supplement-quality",
  support: "https://support.fullscript.com/hc/en-us",
  supportPractitioner: "https://fullscript.com/support",
  supportPatient: "https://fullscript.com/support?mod=patient",
  termsOfService: "https://fullscript.com/terms-of-service",
  testimonials: "https://fullscript.com/testimonials",
  treatmentAdherence: "https://fullscript.com/treatment-adherence",
  webinars: "https://fullscript.com/webinars",
  wholesale: "https://fullscript.com/wholesale",
  wholesaleShipping:
    "https://support.fullscript.com/hc/en-us/articles/360047665712-Wholesale-shipping-policy",

  // fullscript social links
  twitter: "https://twitter.com/FullscriptHQ",
  facebook: "https://www.facebook.com/Fullscript/",
  youtube: "https://www.youtube.com/fullscript",
  instagram: " https://www.instagram.com/fullscript/",
  pinterest: "https://www.pinterest.ca/fullscript/",
  linkedin: "https://ca.linkedin.com/company/fullscript",
} as const;
